import { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

import { toggleSpotModal } from 'actions/spot';
import { isOnSpotRouteNative } from 'components/SpotTradingIndia/Modal/helpers';
import { IS_INDIAN_EXCHANGE } from 'constants/constants';
import useSpotTradingAccess from 'hooks/useSpotTradingAccess';

/**
 * Hook to handle opening spot modal from URL parameters
 * Checks for 'openSpot=true' query parameter and validates user access
 */
const useSpotModalFromURL = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { checkAccess, handleSpotAccess } = useSpotTradingAccess({
    skipTracking: true,
    onAccessGranted: () => {
      dispatch(toggleSpotModal(true));
    },
  });

  useEffect(() => {
    const searchParams = new URLSearchParams(history.location.search);
    const shouldOpenSpot = searchParams.get('openSpot') === 'true';

    if (shouldOpenSpot && IS_INDIAN_EXCHANGE) {
      // Validate access before opening modal
      if (checkAccess()) {
        // User has access - open the modal
        dispatch(toggleSpotModal(true));
      } else {
        // User doesn't have access - redirect to login/KYC
        handleSpotAccess();
      }
    } else if (!isOnSpotRouteNative()) {
      dispatch(toggleSpotModal(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history.location]);
};

export default useSpotModalFromURL;
